import { createSlice } from '@reduxjs/toolkit';
import { fetchPhotos, fetchFailedPhotos } from '../thunks/photos';
import { deletePhoto, uploadPhoto } from '../thunks/photo';
import { createFolder } from '../thunks/folder';

const initialState = {
  photos: [],
  failedFiles: [],
  uploadFailedPhotos: [],
  photoIdList: [],
  meta: {},
  pageNumber: 1,
  perPage: 24,
  disableOnUpload: false,
  fetching: false,
  fetchError: '',
  deleting: false,
  deleteError: '',
  uploadingPhotos: false,
  photosCountBeforeUpload: 0,
};

export const photosSlice = createSlice({
  name: 'photos',
  initialState,
  reducers: {
    setPhotosPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setPhotoUploading: (state, action) => {
      state.uploadingPhotos = action.payload;
      state.disableOnUpload = action.payload;
    },
    setPhotosCountBeforeUpload: (state, action) => {
      state.photosCountBeforeUpload = action.payload;
    },
    resetPhotoIdList: (state) => {
      state.photoIdList = [];
    },
    resetPhotos: (state) => {
      state.pageNumber = 1;
      state.photos = [];
    },
    updateFailedFiles: (state, action) => {
      state.failedFiles = action.payload;
    },
  },
  extraReducers: {
    [fetchPhotos.pending]: (state) => {
      state.fetching = true;
    },
    [fetchPhotos.fulfilled]: (state, action) => {
      const { photos, meta } = action.payload;
      state.fetching = false;
      state.meta = meta;
      if (state.pageNumber === 1) {
        state.photos = [...photos];
      } else {
        state.photos = [...state.photos, ...photos];
      }
    },
    [fetchPhotos.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload;
    },
    [deletePhoto.pending]: (state) => {
      state.deleting = true;
    },
    [deletePhoto.fulfilled]: (state, action) => {
      state.deleting = false;
      state.photos = state.photos.filter(
        (photo) => photo.id !== action.payload
      );
    },
    [deletePhoto.rejected]: (state, action) => {
      state.deleting = false;
      state.deleteError = action.payload;
    },
    [uploadPhoto.pending]: (state) => {
      state.disableOnUpload = true;
    },
    [uploadPhoto.fulfilled]: (state, action) => {
      state.photoIdList = [...state.photoIdList, action.payload.id];
      state.photos = [...state.photos, {}];
    },
    [uploadPhoto.rejected]: (state, action) => {
      state.uploadingPhotos = false;
      state.disableOnUpload = false;
      state.fetchError = action.payload;
    },
    [createFolder.fulfilled]: (state) => {
      state.photos = [];
    },
    [fetchFailedPhotos.fulfilled]: (state, action) => {
      state.uploadFailedPhotos = action.payload;
    },
  },
});

export const {
  setPhotosPageNumber,
  setPhotoUploading,
  setPhotosCountBeforeUpload,
  resetPhotoIdList,
  resetPhotos,
  updateFailedFiles,
} = photosSlice.actions;
